export const priorityOptions = [
  { value: "High", label: "High", color: "#FF3B3B" },
  { value: "Medium", label: "Medium", color: "#FF953B" },
  { value: "Low", label: "Low", color: "#3BD8FF" },
  { value: "None", label: "None", color: "#697571" },
];
